export const CPF_Water_Sources_List = (t: any) => [
  {
    Header: t("Farm Code"),
    accessor: "farm_code",
  },
  {
    Header: t("Field Code"),
    accessor: "field_code",
  },
  /* {
      Header: t("Water Inlet Type"),
      accessor: "water_inlet_type",
    }, */
  {
    Header: t("WaterInletCode"),
    accessor: "water_inlet_code",
  },
  {
    Header: t("WaterInletType"),
    accessor: "water_inlet_type",
    Cell: ({ cell: { value } }) => {
      return t(value);
    },
  },
  {
    Header: t("Water_inlet_flow_rate"),
    accessor: "water_inlet_flow_rate",
  },
  {
    Header: t("Inlet_Has_Pressure_Sensor"),
    accessor: "inlet_has_pressure_sensor",
    Cell: ({ cell: { value } }) => {
      return String(value ? t("Yes") : t("No"));
    },
  },
  /* {
      Header: t("well depth"),
      accessor: "well_depth",
  
      toggleHideColumn: true,
      Cell: ({ cell: { value } }) => String(value),
    }, */
  {
    Header: t("Integration_Date_FF"),
    accessor: "integration_date",
  },
];
